<template>
  <div>
    <!-- Trigger Button -->
    <v-btn 
      :disabled="disabled" 
      color="primary" 
      :loading="loading" 
      @click="fetch" 
      text
      class="font-weight-black text-uppercase tracking-widest rounded-lg px-4 transition-fast-in-fast-out h-44"
    >
      <v-icon left size="16">fas fa-file-export</v-icon>
      Exportar
    </v-btn>

    <!-- Download Dialog -->
    <v-dialog v-model="dataReady" max-width="400" transition="scale-transition">
      <v-card class="modern-card overflow-hidden rounded-xl">
        <!-- Premium Header -->
        <div class="bg-grey-light pa-6 border-bottom">
          <div class="d-flex align-center">
            <v-avatar color="primary" size="40" class="mr-4 shadow-sm border-white-sm">
              <v-icon color="white" small>fas fa-download</v-icon>
            </v-avatar>
            <div>
              <div class="text-h6 font-weight-black primary--text lh-1">Exportar Detalle</div>
              <div class="caption grey--text font-weight-bold text-uppercase tracking-wider mt-1">Historial del Producto</div>
            </div>
          </div>
        </div>

        <v-card-text class="text-center pa-8">
          <v-avatar color="primary lighten-5" size="80" class="mb-6">
            <v-icon color="primary" size="40">fas fa-info-circle</v-icon>
          </v-avatar>
          <div class="body-1 primary--text font-weight-bold mb-2">¡Detalle Generado!</div>
          <div class="caption grey--text px-4 mb-6">El desglose de facturaciones para el SKU {{ product ? product.product__sku : '' }} está listo.</div>

          <vue-json-to-csv
            :json-data="items"
            :labels="labels"
            :csv-title="`export_invoices_detail_${product ? product.product__sku : 'product'}`"
            :separator="';'"
            @success="val => handleSuccess(val)"
            @error="val => handleError(val)">
            <v-btn 
              color="success" 
              block 
              large 
              elevation="0"
              height="48"
              class="font-weight-black text-none rounded-lg shadow-sm"
            >
              <v-icon left>fas fa-download</v-icon>
              Descargar Detalle
            </v-btn>
          </vue-json-to-csv>
        </v-card-text>

        <v-divider class="mx-8 opacity-10"></v-divider>
        <div class="pa-4 text-center">
          <v-btn text small color="grey" class="text-none font-weight-bold" @click="dataReady = false">Cerrar</v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import notifications from '@/utils/notifications'
import {fetchInvoicedDetailByProducts} from '@/api/reports'
import VueJsonToCsv from 'vue-json-to-csv'
import moment from 'moment'

export default {
  name: "ExportProductInvoiceDetail",
  props: ['product', 'filter', 'options', 'disabled'],
  components: { VueJsonToCsv },
  data() {
    return {
      loading: false,
      items: [],
      dataReady: false,
      labels: { 
        dte__date_emited: { title: 'Emitido' },
        dte__document_id: { title: 'Documento' },
        dte__rznSocRecep: { title: 'Razon Social' },
        dte__work_order__id: { title: 'OT' },
        dte__work_order__sales_note__id: { title: 'Cotización' },
        dte__work_order__sales_note__name: { title: 'Proyecto' },
        avg_price: { title: 'Precio Promedio' },
        qty: { title: 'Cantidad' },
        total: { title: 'Neto' },
      }
    }
  },
  methods: {
    async fetch() {
      this.loading = true
      const { sortBy, sortDesc } = this.options
      let sort = (sortDesc && sortDesc[0] ? '-' + (sortBy ? sortBy[0] : 'dte__date_emited') : (sortBy ? sortBy[0] : 'dte__date_emited'))
      
      const query = `page=1&ordering=${sort}&product=${this.product?.product || ''}&emited_after=${this.filter.created_after || ''}&emited_before=${this.filter.created_before || ''}&dte__customer__seller__id=${this.filter.seller || ''}`
      
      await fetchInvoicedDetailByProducts(query)
        .then((res) => {
          this.items = res.results
          this.dataReady = true
        })
        .catch((err) => notifications.showError('Error cargando documentos: ' + err))
        .finally(() => this.loading = false)
    },
    handleSuccess(val) {
      notifications.showSuccess('Detalle Exportado')
      this.dataReady = false
    },
    handleError(val) {
      notifications.showError('Error Exportando Detalle')
      this.dataReady = false
    }
  }
}
</script>

<style scoped>
.modern-card { border-radius: 12px !important; font-family: 'Outfit', sans-serif !important; }
.bg-grey-light { background-color: #f8fafc !important; }
.border-bottom { border-bottom: 1px solid rgba(0,0,0,0.06) !important; }
.border-white-sm { border: 2px solid white !important; }
.shadow-sm { box-shadow: 0 4px 12px rgba(0,0,0,0.05) !important; }
.h-44 { height: 44px !important; }
.lh-1 { line-height: 1 !important; }
.tracking-widest { letter-spacing: 1.5px; }
.tracking-wider { letter-spacing: 0.8px; }
</style>